<template>
  <div class="container mt-2">
    <empresa-combo
      :selected="empresaSelecionada"
      :selecionar="selectEmpresa"
    ></empresa-combo>
    <div v-if="empresaSelecionada" class="mt-3 mb-3">
      <h4>Aplicativos</h4>

      <aplicativos
        :dados="empresaSelecionada.configs.apps"
        @change="changeApp"
      ></aplicativos>
    </div>
  </div>
</template>

<script>
import EmpresaCombo from "../../components/empresa/EmpresaCombo.vue";
import Aplicativos from "../../components/empresa/Aplicativos.vue";
import EmpresasLib from "../../libs/EmpresasLib";
export default {
  components: {
    EmpresaCombo,
    Aplicativos,
  },
  props: {},
  mounted() {
    this.selectEmpresa(this.$store.state.empresa.empresa);
  },
  data() {
    return {
      empresaSelecionada: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    async selectEmpresa(empresa) {
      console.log("selectEmpresa", empresa);
      let empresas = (await EmpresasLib.get())?.data;
      console.log("empresas", empresas);
      this.empresaSelecionada = empresas.find(
        (e) => e.cod_empresa === empresa.cod_empresa
      );
    },
    async changeApp(app){
        console.log("changeApp", app)
        if(this.empresaSelecionada && this.empresaSelecionada.configs){
          this.empresaSelecionada.configs.apps = app;
          console.log("empresaSelecionada", this.empresaSelecionada)
          await EmpresasLib.store(this.empresaSelecionada);
          this.$swal.fire(
            {
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                icon: "success",
                title: "Configurações de aplicativos atualizadas!",
            }
          );
        }
        // this.empresaSelecionada.configs.apps = app;
        // EmpresasLib.save(this.empresaSelecionada);
    }
  },
};
</script>

<style lang="scss" scoped></style>
